import { AttentionMessage } from '@tq/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MAX_FILE_COUNT, MAX_FILE_SIZE } from '../../../constants';
import { allowedFileTypes } from '../../../tools';

const StyledList = styled.ul`
  list-style: none;

  li {
    padding-block: 0.5rem;
  }
  li:before {
    content: '-';
    padding-right: 4px;
  }
`;

export const FileInformation: React.FC = () => {
  const { t } = useTranslation('file_upload');
  return (
    <AttentionMessage
      status='info'
      title={t('upload_file_title', 'Files uploaded must be:')}
      description={
        <StyledList>
          <li>
            {t('upload_documents_max_size_of', 'a max file size of')} :{' '}
            {MAX_FILE_SIZE / 1000000}
            MB
          </li>
          <li>
            {t('upload_documents_max_number_pre', 'a maximum of ')} : {MAX_FILE_COUNT}{' '}
            {t('upload_documents_max_number_post', 'in total')}
          </li>
          <li>
            {t('upload_documents_allowed_list_of', 'of file type')} : {allowedFileTypes}
          </li>
        </StyledList>
      }
      w='100%'
      className='attention-message-small'
    />
  );
};
